var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIconUniversalWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.13754 11.9938C0.843338 12.0111 0.553997 11.9122 0.330534 11.7178C-0.110178 11.2693 -0.110178 10.545 0.330534 10.0965L9.98068 0.33402C10.4391 -0.0998917 11.1583 -0.0757709 11.5873 0.387942C11.9751 0.807275 11.9977 1.4518 11.6402 1.89787L1.93318 11.7178C1.7126 11.9093 1.4279 12.0081 1.13754 11.9938Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7763 11.9938C10.4782 11.9925 10.1924 11.8728 9.98068 11.6603L0.330496 1.89783C-0.0778002 1.41549 -0.0222901 0.689586 0.454505 0.276501C0.880057 -0.092167 1.50766 -0.092167 1.93318 0.276501L11.6402 10.039C12.0984 10.473 12.1221 11.2007 11.6931 11.6643C11.676 11.6827 11.6584 11.7006 11.6402 11.7178C11.4025 11.9269 11.0897 12.0268 10.7763 11.9938Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconUniversalWhite);
export default __webpack_public_path__ + "static/media/CloseIconUniversalWhite.584192d5fcd992e7e4296086dd53a211.svg";
export { ForwardRef as ReactComponent };